"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Write a {@link BinaryValue} update constraint to the stream
 */
function write(bos, value) {
    Codec.writeBytes(bos, value.getBytes().asBuffer());
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/binary-value-serialiser.js
// module id = 1481
// module chunks = 0